/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_06_Detail_Amateur_0_HeadingInputs */

const en_method_content_step_06_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Dissipation of Force: A Foundational Principle for Injury Prevention and Sustained Performance in Golf`)
};

const es_method_content_step_06_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La disipación de la fuerza: un principio fundacional para la prevención de lesiones y el rendimiento sostenido en el golf`)
};

const de_method_content_step_06_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Zerstreuung der Kraft: Ein Grundprinzip für die Verletzungsprävention und nachhaltige Leistung im Golfsport`)
};

const zh_method_content_step_06_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`力量消散：高尔夫中预防伤病和保持长期表现的基本原则`)
};

const ar_method_content_step_06_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تبديد القوة: مبدأ تأسيسي للوقاية من الإصابات والأداء المستدام في الغولف`)
};

const fr_method_content_step_06_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La dissipation de la force : un principe fondamental pour la prévention des blessures et une performance soutenue au golf`)
};

const vi_method_content_step_06_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiêu tán lực: nguyên tắc nền tảng cho phòng chấn thương và hiệu suất bền vững trong golf`)
};

const sw_method_content_step_06_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utawanyaji wa nguvu: kanuni ya msingi ya kuzuia majeraha na kudumisha utendaji katika gofu`)
};

const th_method_content_step_06_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การกระจายแรง: หลักการพื้นฐานเพื่อป้องกันการบาดเจ็บและรักษาประสิทธิภาพการเล่นกอล์ฟในระยะยาว`)
};

const bs_method_content_step_06_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disipacija sile: temeljni princip za prevenciju povreda i održiv performans u golfu`)
};

const ja_method_content_step_06_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォースの普及: ゴルフにおける怪我予防と持続的なパフォーマンスのための基礎原則`)
};

const ko_method_content_step_06_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`힘의 분산: 부상 예방과 골프에서의 지속 가능한 퍼포먼스를 위한 기초 원리`)
};

const pt_method_content_step_06_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A dissipação da força: um princípio fundamental para a prevenção de lesões e desempenho sustentado no golfe`)
};

const it_method_content_step_06_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La dissipazione della forza: un principio fondamentale per la prevenzione delle lesioni e le prestazioni prolungate nel golf`)
};

const sv_method_content_step_06_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skillnaden av kraft: En grundläggande princip för skador förebyggande och hållbar prestanda i golf`)
};

const nl_method_content_step_06_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De dissipatie van de macht: een grondbeginsel voor letselpreventie en duurzame prestaties in Golf`)
};

const da_method_content_step_06_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kraftfordeling: et grundprincip for skadeforebyggelse og varig præstation i golf`)
};

const nb_method_content_step_06_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forsvarets dissipasjon: Et grunnleggende prinsipp for skadeforebygging og uunngåelig ytelse i golf`)
};

const fi_method_content_step_06_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voiman häipyminen: Vammojen ehkäisyn ja jatkuvan suorituskyvyn periaate Golfissa`)
};

const pl_method_content_step_06_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Dissipation of Force: A Foundational Principle for Prevention Hurature and Trwały Performance in Golf`)
};

const ru_method_content_step_06_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Распространение силы: основополагающий принцип предотвращения травм и устойчивой производительности в гольфе`)
};

const tr_method_content_step_06_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuvvetin Dağıtılması: Golfte Sakatlıkların Önlenmesi ve Sürdürülebilir Performans İçin Temel Bir İlke`)
};

const hi_method_content_step_06_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सेना का विघटन: गोल्फ में चोट की रोकथाम और स्थायी प्रदर्शन के लिए एक फाउंडेशनल सिद्धांत`)
};

const id_method_content_step_06_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penyebaran Gaya: Prinsip Dasar untuk Pencegahan Cedera dan Performa Berkelanjutan dalam Golf`)
};

const ms_method_content_step_06_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penyebaran Daya: Prinsip Asas untuk Pencegahan Kecederaan dan Prestasi Berterusan dalam Golf`)
};

const cs_method_content_step_06_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozptyl síly: Základní princip pro prevenci zranění a trvalý výkon v golfu`)
};

const el_method_content_step_06_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Η Disipation of Force: Μια θεμελιώδης αρχή για την πρόληψη των τραυματισμών και τη διαρκή απόδοση στο γκολφ`)
};

const he_method_content_step_06_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הניתוק של כוח: עקרון יסוד לפציעה וביצועים בגולף`)
};

const af_method_content_step_06_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die verspreiding van krag: 'n grondbeginsel vir beseringsvoorkoming en volgehoue prestasie in gholf`)
};

const hu_method_content_step_06_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az erőelvezetés: a sérülésmegelőzés és a tartós teljesítmény alapelve a golfban`)
};

/**
* | output |
* | --- |
* | "The Dissipation of Force: A Foundational Principle for Injury Prevention and Sustained Performance in Golf" |
*
* @param {Method_Content_Step_06_Detail_Amateur_0_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_06_detail_amateur_0_heading = /** @type {((inputs?: Method_Content_Step_06_Detail_Amateur_0_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_06_Detail_Amateur_0_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_06_detail_amateur_0_heading(inputs)
	if (locale === "de") return de_method_content_step_06_detail_amateur_0_heading(inputs)
	if (locale === "zh") return zh_method_content_step_06_detail_amateur_0_heading(inputs)
	if (locale === "ar") return ar_method_content_step_06_detail_amateur_0_heading(inputs)
	if (locale === "fr") return fr_method_content_step_06_detail_amateur_0_heading(inputs)
	if (locale === "vi") return vi_method_content_step_06_detail_amateur_0_heading(inputs)
	if (locale === "sw") return sw_method_content_step_06_detail_amateur_0_heading(inputs)
	if (locale === "th") return th_method_content_step_06_detail_amateur_0_heading(inputs)
	if (locale === "bs") return bs_method_content_step_06_detail_amateur_0_heading(inputs)
	if (locale === "ja") return ja_method_content_step_06_detail_amateur_0_heading(inputs)
	if (locale === "ko") return ko_method_content_step_06_detail_amateur_0_heading(inputs)
	if (locale === "pt") return pt_method_content_step_06_detail_amateur_0_heading(inputs)
	if (locale === "it") return it_method_content_step_06_detail_amateur_0_heading(inputs)
	if (locale === "sv") return sv_method_content_step_06_detail_amateur_0_heading(inputs)
	if (locale === "nl") return nl_method_content_step_06_detail_amateur_0_heading(inputs)
	if (locale === "da") return da_method_content_step_06_detail_amateur_0_heading(inputs)
	if (locale === "nb") return nb_method_content_step_06_detail_amateur_0_heading(inputs)
	if (locale === "fi") return fi_method_content_step_06_detail_amateur_0_heading(inputs)
	if (locale === "pl") return pl_method_content_step_06_detail_amateur_0_heading(inputs)
	if (locale === "ru") return ru_method_content_step_06_detail_amateur_0_heading(inputs)
	if (locale === "tr") return tr_method_content_step_06_detail_amateur_0_heading(inputs)
	if (locale === "hi") return hi_method_content_step_06_detail_amateur_0_heading(inputs)
	if (locale === "id") return id_method_content_step_06_detail_amateur_0_heading(inputs)
	if (locale === "ms") return ms_method_content_step_06_detail_amateur_0_heading(inputs)
	if (locale === "cs") return cs_method_content_step_06_detail_amateur_0_heading(inputs)
	if (locale === "el") return el_method_content_step_06_detail_amateur_0_heading(inputs)
	if (locale === "he") return he_method_content_step_06_detail_amateur_0_heading(inputs)
	if (locale === "af") return af_method_content_step_06_detail_amateur_0_heading(inputs)
	if (locale === "hu") return hu_method_content_step_06_detail_amateur_0_heading(inputs)
	return en_method_content_step_06_detail_amateur_0_heading(inputs)
});